import {VueWizard} from "@/vue-wizard";
import {Component} from "vue-property-decorator";
import {PlanInfo} from "@/app/interfaces/plan-info";
import {store} from "@/app/store";
const _ = require('lodash');

@Component({
    name: "plan-selector"
})
export default class PlanSelector extends VueWizard {

    async mounted() {
        if(this.plansInfo.length === 0) {
            await store.dispatch('loadPlansInfo')
        }
    }

    get plansInfo(): PlanInfo[] {
        return store.state.plansInfo
    }

    selectPlan(plan: PlanInfo){
        const formData = _.cloneDeep(this.$store.state.formData);
        formData.licensing = plan.groupId;
        this.$store.commit('setFormData', formData);
        if(store.state.templateCompanyId !== plan.templateCompanyId) {
            this.$store.commit('setFlows', [])
        }
        this.$store.commit('setTemplateCompanyId', plan.templateCompanyId);
        this.next()
    }

    channelIcon(channel: string): string | string[] {
        channel = channel.toLowerCase();
        if(channel.includes('messenger')) {
            return ['fab', 'facebook-messenger']
        } else if(channel.includes('whatsapp')) {
            return ['fab', 'whatsapp']
        } else if(channel.includes('messagebird')) {
            return 'dove'
        } else {
            return 'comment'
        }
    }

    next(){
        const registerActions = _.cloneDeep(this.$store.state.registerActions);
        registerActions[2].isBlocked = false;
        this.$store.commit('setRegisterActions', registerActions);
        this.$store.commit('setCurrentActionIndex', 2);
    }

}